import { apiClient } from '../instance';

export interface RoleInfo {
  code: string;
  label: string;
  is_internal: boolean;
}

export interface UserWithRole {
  id: number;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  patronymic: string;
  is_staff: boolean;
  is_superuser: boolean;
  groups: string[];
  role: string;
  role_label: string;
  company_name: string | null;
}

export interface CreateInternalUserData {
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  patronymic?: string;
  password: string;
  role: string;
}

// 'company' остаётся как тип для верхнеуровневых COMPANY-инвайтов
// (регистрация компании). Гостевые инвайты выпилены из продукта.
export type InviteType = 'employee' | 'company';
export type InviteStatus = 'unused' | 'used' | 'blocked';

export interface InviteWithMeta {
  id: string;
  name: string;
  type: InviteType;
  status: InviteStatus;
  target_role: string | null;
  target_role_label: string | null;
  created_at: string;
  owner_id: number | null;
  owner_name: string | null;
  company_id: number | null;
  company_name: string | null;
}

export interface CreateInviteData {
  name: string;
  type: 'employee';
  target_role: string;
  /**
   * Компания, в которую приглашаем. Обязательно для админа FMeter
   * (у него своей компании нет). Для OWNER'а игнорируется — берётся
   * его собственная компания.
   */
  target_company?: number;
  /**
   * Имя/фамилия приглашаемого. Бэкенд сохраняет их в
   * Invite.partial_data, и страница регистрации по инвайту
   * подставляет в форму. Если не заданы — поля будут пустыми
   * и юзер заполнит их сам, но это плохой UX (баг, который
   * мы как раз чиним).
   */
  first_name?: string;
  last_name?: string;
}

export const rolesApi = {
  // ── users ──
  getUsers: (params?: { role?: string; search?: string; company?: number }) =>
    apiClient.get<UserWithRole[]>('/roles/users/', { params }),

  changeRole: (userId: number, role: string) =>
    apiClient.post<UserWithRole>('/roles/users/change_role/', {
      user_id: userId,
      role,
    }),

  createInternal: (data: CreateInternalUserData) =>
    apiClient.post<UserWithRole>('/roles/users/create_internal/', data),

  // ── roles ──
  getAvailableRoles: () => apiClient.get<RoleInfo[]>('/roles/available/'),

  // ── invites ──
  getInvites: (params?: { type?: InviteType; status?: InviteStatus }) =>
    apiClient.get<InviteWithMeta[]>('/roles/invites/', { params }),

  createInvite: (data: CreateInviteData) =>
    apiClient.post<InviteWithMeta>('/roles/invites/create/', data),

  revokeInvite: (inviteId: string) =>
    apiClient.post<InviteWithMeta>(`/roles/invites/${inviteId}/revoke/`),
};
